import type React from "react";
import { TextNoteEditor } from "@/components/TextNoteEditor";
import { useFolderId } from "@/hooks/useFolderId";

export const NewTextNote: React.FC = () => {
  const folderId = useFolderId();

  return <TextNoteEditor isCreating={true} folderIdParam={folderId} />;
};
